export const theme = {
    token: {
        screenLGMax: 1280,
        screenXL: 1281,
        screenXLMin: 1281,
    },
    components: {
    },
};
